import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = {
  key: 0,
  class: "text-container"
}

import { computed, ref } from 'vue'
interface Props {
  checked?: boolean
  description?: string
  disabled?: boolean
  error?: string | undefined
  title?: string
  valid?: boolean | undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckBoxStandard',
  props: {
    checked: { type: Boolean, default: false },
    description: { default: '' },
    disabled: { type: Boolean, default: false },
    error: { default: undefined },
    title: { default: '' },
    valid: { type: Boolean, default: undefined }
  },
  emits: ["valueChanged"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const id = ref<string>(`checkbox-${Math.random()}`)

const props = __props

const backgroundColor = computed<string>(() => {
  return checked.value ? 'checked' : 'unchecked'
})

const borderColor = computed<string>(() => {
  if (disabled.value) return 'disabled'
  if (error.value) return 'error'
  if (checked.value) return 'checked'
  return 'default'
})

const checked = computed<boolean>(() => {
  return props.checked
})
const disabled = computed<boolean>(() => {
  return props.disabled
})
const error = computed<string | undefined>(() => {
  return props.error
})
const glowColor = computed<string>(() => {
  if (disabled.value) return 'disabled'
  if (error.value) return 'error'
  return 'default'
})

function handleChange(event: Event) {
  if (!disabled.value) emits('valueChanged', event)
}
function handleDisabledClick(event: Event) {
  if (disabled.value) {
    event.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-container", [glowColor.value]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["checkbox", [borderColor.value, backgroundColor.value]]),
        onClick: handleDisabledClick
      }, [
        _createElementVNode("input", {
          id: id.value,
          type: "checkbox",
          checked: checked.value,
          onChange: handleChange
        }, null, 40, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(["checkmark", { disabled: disabled.value }])
        }, null, 2)
      ], 2)
    ], 2),
    (_ctx.title || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass({ disabled: disabled.value })
          }, _toDisplayString(_ctx.title), 3),
          _createElementVNode("span", null, _toDisplayString(_ctx.description), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})